<nav class="navbar navbar-expand-lg navbar-dark">

  <a class="navbar-brand" href="#">
    <img src="assets/images/rne-logo-white.svg" alt="RNE logo"/>
  </a>

  <ul class="navbar-nav">
    <li class="dropdown" ngbDropdown>
      <a [routerLink]="['dashboard']" ngbDropdownItem>{{'navigation.dashboard' | translate}}</a>
    </li>
    <li class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="dashboard-menu-item" ngbDropdownToggle>
        {{'navigation.searchAndManage' | translate}}
      </a>

      <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dashboard-menu-item">
        <li *pcsShowIfUser="[userType.APPLICANT]">
          <a *pcsHideIfReadonlyUser
             [routerLink]="['dossier/dossier-wizard/basic-data']"
             [queryParams]="{dossierDraftId: ''}" ngbDropdownItem>
            {{'dossierWizard.title' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['dashboard/advanced-search']" ngbDropdownItem>
            {{'dashborad.advancedSearch' | translate}}
          </a>
        </li>
        <li *pcsShowIfUser="[userType.ADMIN, userType.RNEJO]">
          <a [routerLink]="['border-harmonization-search']"  ngbDropdownItem>
            {{'navigation.borderHarmonizationSearch' | translate}}
          </a>
        </li>
        <li class="dropdown-submenu" *pcsHideIfReadonlyUser>
          <a href="#">{{'navigation.bulkEditing' | translate}}</a>
          <ul class="dropdown-menu">
            <li>
              <a [routerLink]="['bulk/acceptance-indicator']" ngbDropdownItem>
                {{'navigation.bulkEditing.acceptanceIndicator' | translate}}
              </a>
            </li>
            <li *pcsShowIfUser="[userType.IM]">
              <a [routerLink]="['bulk/permanent-acceptance']" ngbDropdownItem>
                {{'navigation.bulkEditing.permanentAcceptance' | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['bulk/dossier-promotion']" ngbDropdownItem>
                {{'navigation.bulkEditing.dossierPromotion' | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['bulk/carry-forward/search']" ngbDropdownItem>
                {{'carryForward.title' | translate}}
              </a>
            </li>
            <li *pcsShowIfUser="[userType.APPLICANT]">
              <a [routerLink]="['bulk/ru-appointment']" ngbDropdownItem>
                {{'label.ru.appointment' | translate}}
              </a>
            </li>
            <li *pcsShowIfUser="[userType.APPLICANT, userType.RU]">
              <a [routerLink]="['bulk/ru-appointment-processing']" ngbDropdownItem>
                {{'label.ru.appointment.processing' | translate}}
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a [routerLink]="['reporting']" ngbDropdownItem>{{'headertab.downloads' | translate}}</a>
        </li>
      </ul>
    </li>

    <li class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="pre-const-prod-menu-item" ngbDropdownToggle>
        {{'headertab.paps' | translate}}
      </a>

      <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="pre-const-prod-menu-item">
        <li>
          <a [routerLink]="['pap/search/default']" ngbDropdownItem>
            {{'navigation.papSearch' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['pamt-search']" ngbDropdownItem>
            {{'navigation.pamtSearch' | translate}}
          </a>
        </li>
        <ng-container *pcsHideIfReadonlyUser>
          <li *pcsShowIfUser="[userType.IM, userType.COSS]">
            <a [routerLink]="['pap-import']" ngbDropdownItem>
              {{'navigation.excelImporter' | translate}}
            </a>
          </li>
        </ng-container>
        <li *pcsShowIfUser="[userType.ADMIN, userType.COSS]">
          <a [routerLink]="['rfc-kpi-reports']" ngbDropdownItem>
            {{'rfcKpiReports.title' | translate}}
          </a>
        </li>
        <li *pcsShowIfUser="[userType.ADMIN, userType.COSS, userType.IM]">
          <a [routerLink]="['distance-editor']" ngbDropdownItem>
            {{'label.distance.editor' | translate}}
          </a>
        </li>
      </ul>

    </li>

    <li class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="administration-menu-item" ngbDropdownToggle>
        {{'headertab.coordination' | translate}}
      </a>

      <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="administration-menu-item">
        <li class="dropdown-submenu">
          <a>{{'administration.referenceData' | translate}}</a>
          <ul class="dropdown-menu">
            <li>
              <a [routerLink]="['administration/activity-types']" ngbDropdownItem>
                {{'activityTypes.title' | translate}}
              </a>
            </li>
            <li>
              <a routerLink="administration/common-mandatory-parameters" ngbDropdownItem>
                {{'administration.commonTrainParameters' | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['administration/im-parameters']" ngbDropdownItem>
                {{'label.im.parameters' | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['administration/loco-types']" ngbDropdownItem>
                {{'label.loco.types' | translate}}
              </a>
            </li>
            <li>
              <a [routerLink]="['administration/operation-points']" ngbDropdownItem>
                {{'operationPoints.title' | translate}}
              </a>
            </li>
          </ul>
        </li>
        <li class="dropdown-submenu" *pcsShowIfUser="[userType.APPLICANT, userType.IM, userType.COSS, userType.ADMIN]">
          <a>{{'dossiersearch.templateManagerTitle' | translate}}</a>
          <ul class="dropdown-menu">
            <li>
              <a *pcsShowIfUser="[userType.APPLICANT, userType.IM, userType.ADMIN]"
                 [routerLink]="['administration/template-manager', ttp.id, 'train-parameters']" ngbDropdownItem>
                {{'general.label.train.parameters' | translate}}
              </a>
            </li>
            <li>
              <a *pcsShowIfUser="[userType.IM, userType.COSS, userType.ADMIN]"
                 [routerLink]="['administration/template-manager', ttp.id, 'parameter-set-codes']" ngbDropdownItem>
                {{'label.parameter.set.codes' | translate}}
              </a>
            </li>
          </ul>
        </li>
        <li *pcsShowIfUser="[userType.APPLICANT, userType.IM]">
          <a [routerLink]="['administration/traffic-periods']" ngbDropdownItem>
            {{'navigation.trafficPeriods' | translate}}
          </a>
        </li>
        <li *pcsShowIfUser="[userType.APPLICANT]">
          <a [routerLink]="['administration/acceptance-gtc']" ngbDropdownItem>
            {{'label.gtc.acceptance' | translate}}
          </a>
        </li>
      </ul>

    </li>

    <li *pcsShowIfRole="webServicesTabUserRoles" class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="web-services-admin" ngbDropdownToggle>
        {{'navigation.webservices' | translate}}
      </a>
      <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="web-services-admin">
        <li *pcsShowIfUser="[userType.ADMIN]">
          <a [routerLink]="['web-services/agency-data']" ngbDropdownItem>
            {{'webservices.agencydata.title' | translate}}
          </a>
        </li>
        <li *pcsShowIfUser="[userType.ADMIN]">
          <a *ngIf="false" [routerLink]="['web-services/agency-notifications']" ngbDropdownItem>
            {{'webservices.agencynotifications.title' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['web-services/mediation-protocol']" ngbDropdownItem>
            {{'webservices.mediationprotocol.title' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['web-services/status-codes']" ngbDropdownItem>
            {{'webservices.statuscodes.title' | translate}}
          </a>
        </li>
      </ul>
    </li>

  </ul>
</nav>
